


















import { DEBOUNCE_SLOW } from '~/constants/debounce'
import { debounce } from '~/utils/function'
import { defineComponent, ref, watch } from '~/utils/nuxt3-migration'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'

export default defineComponent({
  props: facetHandlerComponentProps,
  setup(props) {
    const { changeParams } = useClassifiedSearchFacet()

    const query = ref(
      Array.isArray(props.selected) && props.selected.length > 0
        ? props.selected[0].toString()
        : props.value || ''
    )

    watch(
      () => props.selected,
      selected => {
        query.value =
          Array.isArray(selected) && selected.length > 0
            ? selected[0].toString()
            : props.value || ''
      }
    )

    function onClear() {
      query.value = ''

      changeParams([
        {
          name: props.urlArgNames[0],
          value: null
        }
      ])
    }

    const onInput = debounce((text: string) => {
      changeParams([
        {
          name: props.urlArgNames[0],
          value: text
        }
      ])
    }, DEBOUNCE_SLOW)

    return {
      query,
      onClear,
      onInput
    }
  }
})
